import React, { useCallback, useState, useEffect, type FC } from 'react'
import Navbar from './navbar/Navbar'
import Sidebar from './sidebar/Sidebar'
import './layout.css'
import { Routes, Route, useNavigate } from 'react-router-dom'
import { authenticatedAcRoutes, authenticatedRoutes, unAuthenticatedRoutes } from './layoutRoutes'
import PropTypes from 'prop-types'
import { useScreenSize } from '../globalUtils/globalHooks'
import appUser from '../auth/service/AppUser'
import { Toasters, useAppSelector } from '../globalUtils/globalExports'
import { getGlobalReducer } from '../rmsReduxStore/reduxExports'

export const SidebarProps = {
  expandSideBar: PropTypes.bool.isRequired,
  handleSidebarToggle: PropTypes.func
}

export type SidebarPropTypes = PropTypes.InferProps<typeof SidebarProps>

const AppLayout: FC = () => {
  const [expandSideBar, setExpandSideBar] = useState(true)
  const screenSize = useScreenSize?.()
  const handleSidebarToggle = useCallback((val) => { setExpandSideBar(val) }, [])
  const {hideSideBar,acAndDcToggleState} = useAppSelector(getGlobalReducer)
  const isLoggedIn = appUser.isLoggedIn();
  const routes     = isLoggedIn ? ( acAndDcToggleState ==='AC' ? authenticatedAcRoutes() :authenticatedRoutes() ): unAuthenticatedRoutes();
  const navigate = useNavigate();

  useEffect(() => {
    if (screenSize?.width <= 800) {
      handleSidebarToggle(false)
    } else {
      handleSidebarToggle(true)
    }
  }, [screenSize?.width])
  
  useEffect(() => {
  if (!isLoggedIn) return;

  if (acAndDcToggleState === 'AC' && !location.pathname.startsWith('/ac')) {
    navigate('/ac/dashboard', { replace: true });
  }

  if (acAndDcToggleState === 'DC' && location.pathname.startsWith('/ac')) {
    navigate('/dashboard', { replace: true });
  }
}, [acAndDcToggleState, isLoggedIn]);

  return (
      <div className="app__layout">
      {!isLoggedIn && (
         <Routes>
             { routes.map((rmsRoute, index) => <Route key={rmsRoute.path + index} path={rmsRoute.path} element={rmsRoute?.component} />)  }
         </Routes>
        )}
      {isLoggedIn && (
        (
          <>
            <Navbar handleSidebarToggle={handleSidebarToggle} expandSideBar={expandSideBar} />
            <div className="app__layout__container">
              {!hideSideBar && expandSideBar && (
                <Sidebar handleSidebarToggle={handleSidebarToggle} expandSideBar={expandSideBar}/>
              )}
              <div className={ expandSideBar && !hideSideBar ? 'app__route__container ' : 'app__route__container without__side__bar'} >
                <Routes>
                { routes?.filter((route) => route?.isAccessible).map((rmsRoute, index) => <Route key={rmsRoute.path + index}  path={rmsRoute.path} element={rmsRoute?.component} />)  }
                </Routes>
              </div>
              <Toasters />
            </div>
          </>
            )
      )}
      </div>
    )
}
export default AppLayout
